// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"107":"39f8724b","173":"b736bc30","229":"fe257c6f","281":"a9fd0f0a","326":"4b8744f4","400":"7b456f64","556":"403f1ceb","627":"e168edae","685":"6df51254","757":"d25c1891","799":"5ae52d7a","816":"dc65788b","858":"d3ecce11","889":"d880e953"}[chunkId] + ".js";
};